export default "__VITE_ASSET__B77XH4zw__"